// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1E86A","colMin":"styles_colMin__3VIZf","colCheckbox":"styles_colCheckbox__2RfGu"};